<template>
  <div
    class="bb-settings-categories-project-step-item-input"
    @click.stop="onEdit"
  >
    <template v-if="item.isEdit">
      <input
        class="bb-settings-categories-project-step-item-input__field bb-input bb-input_border"
        :class="[item.error && 'bb-input_error']"
        type="text"
        v-autofocus
        :value="item.name"
        @input="onChangeInput($event)"
        @click.stop
      >
      <transition name="bounce" appear>
        <span
          v-if="item.error"
          class="bb-settings-categories-project-step-item-input__error"
        >
          {{item.error}}
        </span>
      </transition>
    </template>
    <span
      v-else
      :style="{color: `rgba(${item.color}, 1)`}"
    >
      {{item.name}}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ExpenseCategoriesListOfProjectStepItemInput',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isError: false
  }),
  methods: {
    onChangeInput ({ target }) {
      const { value } = target
      this.$set(this.item, 'name', value.trim())
      this.$set(this.item, 'error', '')
      this.$emit('resetError')
    },
    onEdit () {
      const { _id } = this.item
      this.$emit('onEdit')
      this.$set(this.item, 'isEdit', _id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bb-settings-categories-project-step-item-input {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    position: relative;

    &__field {
      height: 35px;
      width: 100%;
      padding: 8px 7px;
      font-weight: 500;
      transition: 0.3s;
    }

    &__error {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: $color-pomegranate;
      font-size: 11px;
      line-height: 13px;
      white-space: nowrap;
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/ExpenseCategories/ExpenseCategoriesListOfProject/ExpenseCategoriesListOfProjectStep/ExpenseCategoriesListOfProjectStepItemInput.vue